import { CssRender as e } from "./ghl-ui.es654.js";
const { c } = e(), o = "vueuc-style";
export {
  c,
  o as cssrAnchorMetaName
};
